import { Menu, MenuButton, MenuItems, MenuItem, Transition } from "@headlessui/react";
import React from "react";
import { Link, useNavigate } from "react-router";
import ProfileButton from "./ProfileButton";
import ShareModal from "./ShareModal";
import { ShareIcon } from "@heroicons/react/24/outline";
import useUser from "@app/zustand/user";
import useMedspotStore from "@app/zustand/store";

export default function ProfileDropDown() {
  const me = useUser((state) => state.user!);
  const setIsDrawerOpen = useMedspotStore((state) => state.setDrawerOpen);
  const navigate = useNavigate();
  const handleClick = () => {
    setIsDrawerOpen(false);
  };
  const setUser = useUser((state) => state.setUser);
  return (
    <div className="z-40 h-10 w-10 shrink-0 text-right">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <MenuButton className="inline-flex w-full justify-center font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <ProfileButton user={me} />
          </MenuButton>
        </div>
        <Transition
          as={React.Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems className="absolute right-0 mt-2 max-h-[85vh] w-[95vw] max-w-md origin-top-right divide-y divide-gray-100 overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 ">
              <DropDownButton onClick={handleClick} to={`/users`}>
                Membres
              </DropDownButton>
              {!!me.isMedspotAdmin && (
                <DropDownButton onClick={handleClick} to={`/stats`}>
                  Stats
                </DropDownButton>
              )}
            </div>

            <div className="px-1 py-1 ">
              <DropDownButton onClick={handleClick} to={`/profile/${me?.plausible_id}`}>
                Mon profil
              </DropDownButton>
              {/* <DropDownButton onClick={handleClick} to={`/profile/${me?.plausible_id}`}>
                Modifier mon profil
              </DropDownButton> */}
            </div>
            <div className="px-1 py-1 ">
              <ShareModal onShow={handleClick}>
                <div
                  className={`group flex w-full items-center rounded-md px-2 py-2 text-sm text-gray-900 hover:bg-sky-900 hover:text-white`}
                >
                  <ShareIcon className="pointer-events-none mr-2 size-4" />
                  Partager
                </div>
              </ShareModal>
            </div>
            <div className="px-1 py-1">
              <DropDownButton
                onClick={() => {
                  fetch(`${import.meta.env.VITE_API_URL}/user/logout`, {
                    method: "POST",
                    credentials: "include",
                  });
                  setUser(null);
                  navigate("/welcome");
                }}
              >
                Se déconnecter
              </DropDownButton>
            </div>
            <div className="px-1 py-1">
              <DropDownButton onClick={handleClick} to="/cgus">
                CGUs
              </DropDownButton>
              <DropDownButton onClick={handleClick} to="/confidentialité">
                Politique de Confidentialité
              </DropDownButton>
              <p className={`flex w-full items-center rounded-md px-2 py-2 text-sm text-gray-900 opacity-45`}>
                Copyright Medspot {new Date().getFullYear()} - version 2.3.0
              </p>
            </div>
            {/* <div className="px-1 py-1">
              <DropDownButton onClick={onToggleDarkMode}>
                {isDarkMode ? "Mode sombre" : "Mode clair"}
              </DropDownButton>
            </div> */}
          </MenuItems>
        </Transition>
      </Menu>
    </div>
  );
}

export function DropDownButton({
  children,
  to,
  onClick,
  className = "",
}: {
  children: React.ReactNode;
  to?: string;
  onClick?: () => void;
  className?: string;
}) {
  className = `group flex w-full items-center justify-start rounded-md px-2 py-2 text-left text-sm text-gray-900 hover:bg-sky-900 hover:text-white ${className}`;

  if (to) {
    return (
      <MenuItem>
        <Link to={to} onClick={onClick ? onClick : undefined} className={className}>
          {children}
        </Link>
      </MenuItem>
    );
  }

  return (
    <MenuItem>
      <button type="button" onClick={onClick ? onClick : undefined} className={className}>
        {children}
      </button>
    </MenuItem>
  );
}
